// ag-single-select.component.ts
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { ICellEditorAngularComp } from 'ag-grid-angular';

export interface AgSingleSelectOption {
  ID: number | string;
  Name: string;
}

@Component({
    selector: 'app-ag-single-select',
    templateUrl: './ag-single-select.component.html',
    styleUrls: ['./ag-single-select.component.scss'],
    imports: [
    FormsModule
]
})
export class AgSingleSelectComponent implements ICellEditorAngularComp {
  opts: AgSingleSelectOption[] = [];
  selectedId: number | string;

  agInit(params: any): void {
    this.opts = params.opts || [];
    this.selectedId = params.value;
  }

  getValue(): any {
    return this.selectedId;
  }
}